

const initialState = {
    viewSimulationActive: true,
    viewArchiveActive: false,
}



//-----------------------------------------------------------------



const reducer = (state = initialState, action) => {
    
    switch (action.type) {

        case "CONTENT:SHOW_ARCHIVE":
            console.log("Archive");
            return Object.assign({}, state, {
                viewSimulationActive: false,
                viewArchiveActive: true,
            });

        case "CONTENT:SHOW_SIMULATION":
            console.log("Simulation");
            return Object.assign({}, state, {
                viewSimulationActive: true,
                viewArchiveActive: false,
            });

        default:
            return state;
        
    }
}

export { reducer }

